import { Component,OnInit } from '@angular/core';
import Swiper from 'swiper';
import { Meta, Title } from '@angular/platform-browser';
declare var $: any;

@Component({
  selector: 'app-investment-banking',
  templateUrl: './investment-banking.component.html',
  styleUrls: ['./investment-banking.component.css']
})
export class InvestmentBankingComponent implements OnInit {
 
  classList: any;
  nextElementSibling: any;
  meta_title: string = 'SEBI-Reg. Investment Banking | Bajaj Capital Securities';
  meta_desc: string = 'Get benefit from expert investment banking services with SEBI-registered Bajaj Capital Securities. Partner with us for tailored financial solutions and long-term success.';
  
  constructor(private metaService: Meta,private titleService: Title){ }

  ngOnInit(): void {
    this.setMetaTags();
    
    $(document).ready(() => {
      const menuBtns = document.querySelectorAll('.menu-button');
      menuBtns.forEach((menuBtn) => {
        menuBtn.addEventListener('click', function (this:any) {
          // Open only one menu at a time
          const activeAccordion = document.querySelector('.menu-button.open');
          if (activeAccordion && activeAccordion !== this) {
            const sibling = activeAccordion.nextElementSibling as HTMLElement | null; 
            if (sibling) {
              sibling.style.height = '0';
            }
            (activeAccordion as HTMLElement).classList.remove('open'); 
          }

          this.classList.toggle('open');
          const content = this.nextElementSibling as any;
          if (this.classList.contains('open')) {
            content.style.height = `${content.scrollHeight}px`;
          } else {
            content.style.height = '0';
          }
        });
      });

      const menuBtns2 = document.querySelectorAll('.menu-button2');

      menuBtns2.forEach((menuBtn) => {
        menuBtn.addEventListener('click', function (this:any) {
          const activeAccordion = document.querySelector('.menu-button2.open');
          if (activeAccordion && activeAccordion !== this) {
            const sibling = activeAccordion.nextElementSibling as any | null; 
            if (sibling) {
              sibling.style.height = '0';
            }
            (activeAccordion as any).classList.remove('open'); 
          }

          this.classList.toggle('open');
          const content2 = this.nextElementSibling as any;
          if (this.classList.contains('open')) {
            content2.style.height = `${content2.scrollHeight}px`;
          } else {
            content2.style.height = '0';
          }
        });
      });

      const navbar = $('#main-nav');
      const navPos = navbar.offset().top;
      const navbarLinks = $('.nav button');
      const header = $('#subheader');

      $(window).scroll(() => {
        const scrollPos = $(window).scrollTop();

        const stickyHeader = $('.stickyHeader').offset()?.top || 0;
        if (scrollPos > navPos) {
          navbar.addClass('sticky');
          header.addClass('navbarOffsetMargin');
        } else {
          navbar.removeClass('sticky');
          header.removeClass('navbarOffsetMargin');
        }

        navbarLinks.each(function (this:any) {
          const link = $(this);
          const section = $(link.attr('data-href') as string);
          if (
            scrollPos + 200 > section.offset().top &&
            scrollPos + 200 < section.offset().top + section.outerHeight()
          ) {
            link.addClass('active');
          } else {
            link.removeClass('active');
          }

          if (scrollPos < 350) {
            $('.stickyHeader').removeClass('space');
          } else {
            $('.stickyHeader').addClass('space');
          }
        });
      });

      const sections = {
        partner: $('#partner'),
        association: $('#association'),
        spectrum: $('#spectrum'),
        leadership: $('#leadership'),
        getintouch: $('#getintouch'),
      };
      $('#main-nav #partnertab').click(() =>
        $('html, body').animate({ scrollTop: sections.partner.offset().top - 30 }, 100)
      );
      $('#main-nav #associationtab').click(() =>
        $('html, body').animate({ scrollTop: sections.association.offset().top - 60 }, 100)
      );
      $('#main-nav #spectrumtab').click(() =>
        $('html, body').animate({ scrollTop: sections.spectrum.offset().top - 30 }, 100)
      );
      $('#main-nav #leadershiptab').click(() =>
        $('html, body').animate({ scrollTop: sections.leadership.offset().top - 30 }, 100)
      );
      $('#main-nav #getintouchtab').click(() =>
        $('html, body').animate({ scrollTop: sections.getintouch.offset().top - 30 }, 100)
      );

      if (window.matchMedia('(max-width: 700px)').matches) {
        $('#main-nav #partnertab').click(() =>
          $('html, body').animate({ scrollTop: sections.partner.offset().top - 50 }, 100)
        );
        $('#main-nav #associationtab').click(() =>
          $('html, body').animate({ scrollTop: sections.association.offset().top - 60 }, 100)
        );
        $('#main-nav #spectrumtab').click(() =>
          $('html, body').animate({ scrollTop: sections.spectrum.offset().top - 70 }, 100)
        );
        $('#main-nav #leadershiptab').click(() =>
          $('html, body').animate({ scrollTop: sections.leadership.offset().top - 40 }, 100)
        );
        $('#main-nav #getintouchtab').click(() =>
          $('html, body').animate({ scrollTop: sections.getintouch.offset().top - 40 }, 100)
        );
      }

      // Scroll to top button
      const myButton = document.getElementById('myBtn');
      window.onscroll = function () {
        topFunction();
      };

      function topFunction() {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
          myButton?.classList.add('show');
        } else {
          myButton?.classList.remove('show');
        }
      }

      $(myButton).click(() => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      });
    });
  }
  private setMetaTags(): void {
    this.titleService.setTitle(this.meta_title);
    this.metaService.updateTag({ name: 'description', content: this.meta_desc });
  }
}